import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

const ClientLogin: React.FC = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");

  // Credenciais fictícias para João
  const validEmail = "joao.silva@email.com";
  const validPassword = "joao123";

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setError("");

    // Validação básica
    if (!email || !password) {
      setError("Por favor, preencha todos os campos.");
      return;
    }

    // Validação de email
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setError("Por favor, insira um e-mail válido.");
      return;
    }

    // Verifica credenciais (em produção, isso seria uma chamada à API)
    if (email === validEmail && password === validPassword) {
      // Gera token aleatório de 6 dígitos
      const token = Math.floor(100000 + Math.random() * 900000).toString();
      // Simula envio do código
      navigate("/client/verification", { state: { email, token } });
    } else {
      setError("E-mail ou senha incorretos. Tente novamente.");
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-blue-100 flex items-center justify-center p-4">
      <Card className="w-full max-w-md shadow-lg">
        <CardHeader className="text-center space-y-4 pb-6">
          <div className="mx-auto w-20 h-20 bg-green-600 rounded-full flex items-center justify-center mb-4">
            <span className="text-3xl">🌱</span>
          </div>
          <CardTitle className="text-2xl font-bold text-gray-900">
            Acesse sua conta sustentável
          </CardTitle>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="space-y-2">
              <Label htmlFor="email" className="text-sm font-medium text-gray-700">
                E-mail
              </Label>
              <Input
                id="email"
                type="email"
                placeholder="seu.email@exemplo.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="h-12 text-base"
                required
              />
            </div>
            <div className="space-y-2">
              <Label htmlFor="password" className="text-sm font-medium text-gray-700">
                Senha
              </Label>
              <div className="relative">
                <Input
                  id="password"
                  type={showPassword ? "text" : "password"}
                  placeholder="Digite sua senha"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="h-12 text-base pr-10"
                  required
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700"
                >
                  {showPassword ? "👁️" : "👁️‍🗨️"}
                </button>
              </div>
            </div>
            {error && (
              <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg text-sm">
                {error}
              </div>
            )}
            <Button
              type="submit"
              className="w-full h-12 text-base font-semibold bg-blue-600 hover:bg-blue-700"
            >
              Continuar
            </Button>
          </form>
          <p className="text-xs text-gray-500 text-center mt-6">
            Ainda não tem conta? As contas são criadas automaticamente ao voar com a Aviões S.A.
          </p>
          {/* Informação de login de teste */}
          <div className="mt-4 p-3 bg-gray-100 rounded-lg border border-gray-300">
            <p className="text-xs font-semibold text-gray-700 mb-1">🧪 Login de Teste:</p>
            <p className="text-xs text-gray-600">
              E-mail: <span className="font-mono">{validEmail}</span>
            </p>
            <p className="text-xs text-gray-600">
              Senha: <span className="font-mono">{validPassword}</span>
            </p>
            <p className="text-xs text-gray-600 mt-1">
              O token será gerado automaticamente após o login.
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default ClientLogin;
